import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class PdfViewer extends React.Component {
  static contextTypes = {
    cloudfrontUrl: PropTypes.string,
  };

  static propTypes = {
    fileUrl: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    pageWidth: PropTypes.string,
  };

  static defaultProps = {
    pageWidth: '1366',
  };

  state = {
    isComponentsLoaded: false,
    numPages: null,
  };

  Document = null;

  Page = null;

  async componentDidMount() {
    if (!!window && window !== 'undefined') {
      const { pdfjs, Page, Document } = await import('react-pdf');
      pdfjs.GlobalWorkerOptions.workerSrc = new URL(
        'pdfjs-dist/build/pdf.worker.min.js',
        import.meta.url,
      ).toString();
      this.Document = Document;
      this.Page = Page;
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ isComponentsLoaded: true });
    }
  }

  onDocumentLoaded = ({ numPages }) => {
    this.setState({ numPages });
  };

  render() {
    const { isComponentsLoaded, numPages } = this.state;
    const { fileUrl, className, pageWidth } = this.props;
    const { Document, Page } = this;
    if (!isComponentsLoaded) {
      return null;
    }

    return (
      <Document
        file={fileUrl}
        className={classNames(className)}
        onLoadSuccess={this.onDocumentLoaded}
      >
        {/* eslint-disable-next-line prefer-spread */}
        {Array.apply(null, Array(numPages))
          .map((x, i) => i + 1)
          .map((page, index) => (
            <Page
              width={pageWidth}
              style={{ maxWidth: '100%' }}
              className={classNames(className)}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              pageNumber={page}
              // eslint-disable-next-line react/no-array-index-key
              key={`page-number-${index}`}
            />
          ))}
      </Document>
    );
  }
}
